import script from "./DepositContractView.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositContractView.vue?vue&type=script&setup=true&lang=js"

import "./DepositContractView.vue?vue&type=style&index=0&id=6d712936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d712936"]])

export default __exports__